@use '../shared-styles' as *;

@layer design-system {
  .multiLineChartRoot {
    position: relative;
    overflow: visible;
  }

  .multiLineChartContainer {
    overflow: visible;
  }

  .plot {
    position: relative;
    width: 100%;
    height: 340px;
    overflow: visible;
  }

  .canvasOverlay {
    position: absolute;
    pointer-events: none;
  }

  .tooltipLine {
    @include axis-line;
    stroke-dasharray: 4 4;
  }

  .verticalLine {
    @include axis-line;
    stroke-width: 2px;
  }
}
